<template>
  <div class="col">
    <div class="fm-questionnaire__top">
      <h1 class="sm">Test Your Knowledge</h1>
      <span class="h1">{{ question.prompt }}</span>
    </div>
    <div class="fm-questionnaire__middle">
      <div class="row">
        <div
          v-for="(option, index) in question.options"
          :key="index"
          class="col-12 col-md-6 fm-answers"
        >
          <label class="answer ">
            <input
              :id="`option-${index}`"
              v-model="selection"
              type="radio"
              name="selectOne"
              :value="index"
            >
            <span
              :for="`option-${index}`"
              class="label"
            >{{ option }}
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="fm-questionnaire__bottom">
      <button
        class="btn button btn-medium"
        :class="{submitted: isSubmitted}"
        @click="
          isSubmitted = true;
          validateAnswer(question.correctAnswer);
        "
      >submit</button>
      <div
        v-if="isSubmitted"
        class="answer__submitted"
      >
        <div
          v-if="proceed === true"
        >
          <span class="answer__valid">
            <i
              class="fas fa-check-circle"
              aria-hidden="true"
            />
            {{ question.bottomHeaderTrue }}
          </span>
        </div>
        <div
          v-if="proceed !== true"
        >
          <span
            class="answer__invalid"
          >
            <i
              class="fas fa-times-circle"
              aria-hidden="true"
            />
            {{ question.bottomHeaderFalse }}
          </span>
        </div>
        <p class="answer__bottom">{{ question.bottomText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleChoiceQuestion',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    question: Object,
  },
  data() {
    return {
      selection: null,
      proceed: false,
      isSubmitted: false,
    };
  },
  methods: {
    validateAnswer(correctAnswer) {
      // 'selection' in this case is the index of the item in the array that
      // creates the radio buttons.
      // correctAnswer is the correct answer index.
      this.proceed = correctAnswer === this.selection;
      this.$emit('proceed', this.isSubmitted);
    },
  },
};
</script>

<style>
</style>
